// extracted by mini-css-extract-plugin
export default {"wrapper":"Ix2RlK","text":"IVXwXb","label":"peYvPd","opened":"gp_Jf7"};